import App from './App.svelte';
import './force.css';

window.isExamEnded = false;
var app = new App({
	target: document.body
});

export default app;
